import DetailWrapper from './DetailWrapper'
import ElectionsList from './ElectionsList'
import LandingPageWrapper from './LandingPageWrapper'
import LoginSignup from './LoginSignup'
import MobileSeatList from './MobileSeatList'
import Page from './Page'
import StatesList from './StatesList'

export {
  DetailWrapper,
  ElectionsList,
  LandingPageWrapper,
  LoginSignup,
  MobileSeatList,
  Page,
  StatesList
}



// WEBPACK FOOTER //
// ./src/components/index.js